import React from 'react';
import { SERVICES } from '../seo';
import { useLandingContent, resolveImageUrl } from '../useLandingContent';

// Default progetti se la galleria CMS è vuota
const DEFAULT_PROJECTS = [
  { src: 'https://impresaedilecima.it/wp-content/uploads/2023/10/IMG_4196.jpg', alt: 'Cantiere edile a Calcinato', tag: 'Nuove Costruzioni' },
  { src: SERVICES[1].image, alt: 'Ristrutturazione appartamento a Brescia', tag: 'Ristrutturazioni' },
  { src: SERVICES[2].image, alt: 'Rifacimento tetto con isolamento termico', tag: 'Tetti' },
  { src: SERVICES[3].image, alt: 'Piscina interrata personalizzata', tag: 'Piscine' },
  { src: SERVICES[0].image, alt: 'Edificio in costruzione chiavi in mano', tag: 'Nuove Costruzioni' },
  { src: SERVICES[4].image, alt: 'Manutenzione condominio a Brescia', tag: 'Manutenzioni' },
];

export default function Galleria() {
  const { content } = useLandingContent();
  const cmsItems = (content.galleria || []).map(g => ({
    src: resolveImageUrl(g.url || g.src),
    alt: g.alt || g.descrizione || 'Progetto EDIL CIMA',
    tag: g.tag || g.categoria || '',
  }));
  const projects = cmsItems.length > 0 ? cmsItems : DEFAULT_PROJECTS;

  return (
    <section id="galleria" className="py-20 sm:py-28 bg-stone-100" data-testid="section-galleria">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-[11px] font-black text-primary uppercase tracking-widest mb-3">— I Nostri Progetti</p>
            <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-stone-900 leading-[1.1]">
              Ogni cantiere<br />
              <span className="text-stone-500">è una promessa mantenuta.</span>
            </h2>
          </div>
          <p className="text-stone-600 max-w-md text-sm">Una selezione dei lavori realizzati in provincia di Brescia: nuove costruzioni, ristrutturazioni complete, tetti, piscine e manutenzioni.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
          {projects.map((p, i) => (
            <figure key={i} data-testid={`project-${i}`}
              className={`relative overflow-hidden rounded-lg group cursor-pointer ${i === 0 ? 'col-span-2 md:row-span-2 md:col-span-2' : ''}`}>
              <img src={p.src} alt={p.alt} loading="lazy"
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i === 0 ? 'h-72 md:h-full' : 'h-48 sm:h-56'}`} />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute bottom-3 left-3 right-3">
                {p.tag && <span className="inline-block px-2 py-1 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded mb-1">{p.tag}</span>}
                <p className="text-white text-sm font-semibold drop-shadow-md">{p.alt}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
